import * as React from 'react';

const AuthenticityDiamond32 = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 32 32", width: 32, height: 32, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#F1EAE1",
    d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#007782",
    d: "M17.518 23.51a2 2 0 0 1-3.034 0l-6.367-7.412a2 2 0 0 1-.005-2.601l2.79-3.269a2 2 0 0 1 1.521-.702h7.155a2 2 0 0 1 1.522.702l2.789 3.268a2 2 0 0 1-.004 2.602zm1.825-10.859c-.064-.557-.847-.557-.91 0l-.136 1.172a.466.466 0 0 1-.401.414l-1.135.14c-.54.065-.54.873 0 .94l1.135.139c.21.025.377.197.401.414l.135 1.172c.064.556.847.556.911 0l.135-1.172a.466.466 0 0 1 .401-.414l1.135-.14c.54-.066.54-.874 0-.94l-1.135-.139a.466.466 0 0 1-.401-.414z"
  }
));
AuthenticityDiamond32.Size = 32;
AuthenticityDiamond32.Title = "AuthenticityDiamond";

export { AuthenticityDiamond32 as default };
